import { useQuery } from "@tanstack/react-query";
import { Controller } from "react-hook-form";
import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import { FieldError } from "@/components/ui/field";
import RevenueOpportunityService from "services/RevenueOpportunities";
import RevenueOpportunityStatusPresetService from "services/RevenueOpportunityStatusPreset";
import RevenueOpportunityStatusSelector from "routes/revenue_opportunity_status_presets/components/RevenueOpportunityStatusSelector";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  revenue_opportunity_statuses: z
    .array(z.any())
    .min(1, "Add at least one Revenue Opportunity Status"),
});

const RevenueOpportunityStatusPresetForm = ({ preset, onSuccess }) => {
  const { data: allRevenueOpportunityStatuses = [] } = useQuery({
    queryKey: ["revenue-opportunity-statuses"],
    queryFn: () =>
      RevenueOpportunityService.getRevenueOpportunityStatusesForFilters(),
  });

  const handleSubmit = async values => {
    if (preset) {
      await RevenueOpportunityStatusPresetService.editRevenueOpportunityStatusPreset(
        preset.id,
        values.name,
        values.revenue_opportunity_statuses
      );
    } else {
      await RevenueOpportunityStatusPresetService.createRevenueOpportunityStatusPreset(
        values.name,
        values.revenue_opportunity_statuses
      );
    }
    toast.success("Preset saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: preset?.name || "",
        revenue_opportunity_statuses:
          preset?.info?.revenue_opportunity_statuses || [],
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required />
      <Controller
        name="revenue_opportunity_statuses"
        render={({ field, fieldState }) => (
          <div>
            <RevenueOpportunityStatusSelector
              revenueOpportunityStatuses={field.value}
              setRevenueOpportunityStatuses={field.onChange}
              allRevenueOpportunityStatuses={allRevenueOpportunityStatuses}
            />
            <FieldError>{fieldState.error?.message}</FieldError>
          </div>
        )}
      />
    </BaseForm>
  );
};

export default RevenueOpportunityStatusPresetForm;
